import { sync } from 'vuex-pathify'
import { store } from '@/store/index'

export const notificationTrigger = {
  data () {
    return {
      submitting: false,
      complete: false,
      notification: false
    }
  },
  computed: {
    alert: sync('auth/alert')
  },
  mounted () {
    store.set('auth/alert', null)
  },
  methods: {
    containerHeight () {
      let offsetHeight = document.getElementById('authCon').getBoundingClientRect().top
      let calc = -offsetHeight + 100
      document.querySelector('.authModule').style.top = calc + 'px'
    },
    savingAnimation (status, message) {
      let self = this
      if (status === 'reset') {
        self.notification = false
      } else {
        self.complete = status
        self.notification = {
          'status': status,
          'message': message
        }
        window.setTimeout(() => {
          self.submitting = false
          self.complete = false
        }, 2000)
        if (status !== 'validate') {
          window.setTimeout(() => {
            self.notification = false
          }, 7000)
        }
      }
    },
    loadingFailure (status, message) {
      let self = this
      self.complete = status
      self.notification = {
        'status': status,
        'message': message
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/notification.js